<p>
  {{
    ("components.map.radius" | translate) +
      ": " +
      this.radius.toFixed(1) +
      " km"
  }}
</p>
<p>
  {{
    ("components.map.number-of-leads" | translate) +
      ": " +
      totalNumberOfLeads.toString()
  }}
</p>
<button mat-button (click)="openInputDialog()">
  {{ "components.map.fetch-leads-button" | translate }}
</button>
<div id="allLeadsMap"></div>
